import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { loginRequest } from "./AuthProvider";
import { isAuthDisabled } from "./bootstrapConfig";
import { useRbac } from "./RbacContext";
import { AccessDenied } from "../pages/AccessDenied";
import { Spinner } from "../components/rpe";

function AuthenticatedRoute() {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress, instance } = useMsal();
  const { hasAccess } = useRbac();
  const location = useLocation();

  if (inProgress !== InteractionStatus.None) {
    return (
      <div style={{ textAlign: "center", padding: "80px 0" }}>
        <Spinner />
      </div>
    );
  }

  if (!isAuthenticated) {
    instance.loginRedirect(loginRequest).catch(() => {});
    return <Navigate to="/" replace />;
  }

  if (!hasAccess(location.pathname)) {
    return <AccessDenied />;
  }

  return <Outlet />;
}

export function ProtectedRoute() {
  if (isAuthDisabled()) return <Outlet />;
  return <AuthenticatedRoute />;
}
